module.exports = __webpack_public_path__ + "static/media/first-page.2f2db8d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/first-page.svg
// module id = 859
// module chunks = 0